import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { TariffCalculatorPage } from "./TariffCalculatorPage";
import "./styles/tokens.css";
import "./styles/app.css";

const Root = window.location.pathname === "/calculator" || window.location.pathname === "/calculator/"
  ? TariffCalculatorPage
  : App;

createRoot(document.getElementById("root")!).render(
  <StrictMode><Root /></StrictMode>,
);
